module.exports = "<p>\r\n  perfil works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/perfil/perfil.component.html
// module id = ../../../../../src/app/components/perfil/perfil.component.html
// module chunks = main